// --- components/Hero2.tsx ---

'use client';

// This is a new Hero component with different text content and no right-side image.
const Hero2: React.FC = () => {
  return (
    <section className="relative flex flex-col  overflow-hidden">
      {/* Full Width - Yellow Background with Content */}
      <div className="w-full bg-white flex items-center justify-start p-8 md:p-12 lg:p-16 pb-4 md:pb-6 lg:pb-8 text-left md:text-left">
        <div className="max-w-9xl mx-auto text-gray-900">
          {/* <p className="text-lg md:text-xl text-gray-700 mb-4 font-semibold">
            /Leading Industrial Solutions
          </p> */}
          <h2 className="text-2xl sm:text-5xl lg:text-6xl font-medium leading-tight mb-6">
           <span className="text-yellow-600">At Samsan Inc</span>, we specialize in the reliable supply of high-quality industrial goods, and equipment to meet the demands of diverse sectors, including oil & gas, manufacturing, construction, power & energy, and infrastructure.
          </h2>
          <p className="text-base sm:text-lg text-gray-600 mb-8 max-w-9xl mx-auto leading-relaxed">
           With a strong focus on efficiency, durability, and customer satisfaction, we offer a comprehensive range of products—from parts, spares, components, tools and machinery to safety equipment and maintenance supplies.
          </p>
          {/* <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-4">
            <Button
              variant="default"
              size="lg"
              className="bg-gray-900 hover:bg-gray-700 text-white font-semibold py-3 px-8 rounded-full shadow-lg transition-transform transform hover:scale-105"
            >
              Discover Our Range
            </Button>
            <Button
              variant="ghost"
              size="lg"
              className="text-gray-900 hover:bg-gray-100 font-semibold py-3 px-8 rounded-full transition-transform transform hover:scale-105"
            >
              Learn About Our Expertise
            </Button>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Hero2